export const link = ({ theme: { colors } }) => ({
    color: colors.blue,
    fontSize: '1.25rem',
    textDecoration: 'none',
    fontWeight: 'bold',
    boxShadow: 'inset 0 -0.1875rem #0000FF',
    lineHeight: '2rem',
});

export const extendTitle = {
    title: () => ({
        marginTop: 0,
    }),
};
